import { useId } from "react";

import { Tracker } from "@util/tracker";

import { StyledImage, StyledText, StyledEyebrow } from "./components";
import { BigCardProps, BigCardWithTrackingProps } from "./types";

import styles from "./styles.module.css";

export function Component(props: BigCardProps) {
  return (
    <article className={styles.bigCardContainer}>
      <StyledImage {...props} />
      <div className={styles.bottom} data-skeleton-selector>
        {props.eyebrow && <StyledEyebrow {...props} />}
        <StyledText {...props} />
      </div>
    </article>
  );
}
Component.displayName = "BigCard.Component";

export function WithTracking(props: BigCardWithTrackingProps) {
  const uniqueId = useId();
  const tracker = props.trackingId?.length ? Tracker.getInstance() : undefined;

  return (
    <div
      id={uniqueId}
      data-component="bigCard"
      data-tracking-id={props.trackingId}
      ref={tracker?.registerComponent}
    >
      <Component {...props} tracker={tracker} />
    </div>
  );
}
WithTracking.displayName = "BigCard.WithTracking";
